import React from 'react'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config'

const config = resolveConfig(tailwindConfig)
export const theme = config.theme

export function getBreakpointInPixels (breakpoint: 'xl' | 'md' | 'lg') {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const value = theme.screens[breakpoint]
  return Number(value.substring(0, value.length - 2))
}

export const TailwindContext = React.createContext({
  theme,
  getBreakpointInPixels
})
